import React, { useRef, useState, useEffect } from 'react'
import { Box, Grid } from '@mui/material'
import ReportsService from '../../../../../services/reports.service'
import {
  Modal, MuiButton, MuiTextField, MuiSelect, MuiCheckbox,
  D3Pie, Rte
} from '../../../../../components'
import { IconAddRow, IconMinusRow } from '../../../../../assets/images/icons'
import { LEGEND_COLOR_MAP, GRAPH_COLOR_PALLET1 } from '../../../../../constants'
import ViewWidget from '../viewWidget'
import { Wrapper, LHS, FormInnerWrapper, SectionTitle, FormWrapper, FormRow, RHS, PreviewWrapper, PreviewInnerWrapper, D3PieLegends, LegendLabel, CardPreview, WidgetWrapper, ActionWrapper, InputWrapper, SelectWrapper, D3PieWrapper, RtePreviewCss } from './style'

const EditWidget = ({insightsElementId, data, onClose, onClickEditContent, onWidgetUpdated}) => {
  // const [anchorElUser, setAnchorElUser] = useState(null)
  const initialRowData = {label: '', value1: '', value2: ''}
  const [loading, setLoading] = useState()
  const [form, setForm] = useState({ guid:data.guid, title: data.title, data:[], displayValuesOutsidePie:false })
  const [widgetTypeValue, setWidgetTypeValue] = useState(data?.type || 'NA')
  const [colorValue, setColorValue] = useState('SelectColor')
  const [colorPallet, setColorPallet] = useState([])
  const [colorArray, setColorArray] = useState([])
  const [freeText, setFreeText] = useState(null)
  const [mode, setMode] = useState('add')
  const [showFreeText, setShowFreeText] = useState(1)
  const [saveWidgetStatus, setSaveWidgetStatus] = useState(true)
  const inputRefs = useRef([])

  const widgetTypeArray = [
    {label: 'Select Widget Type', value: 'NA'},
    {label: 'Pie Chart', value: 'Pie', colorArray:['SelectColor', 'SingleColor', 'Multicolor', 'SentimentColors']},
    {label: 'Donut Chart', value: 'Donut', colorArray:['SelectColor', 'SingleColor', 'Multicolor', 'SentimentColors']},
    {label: 'Stat Box', value: 'Box', colorArray:['SelectColor', 'SingleColor', 'Multicolor', 'SentimentColors']},
    {label: 'Vertical Bar Chart', value: 'VBar', colorArray:['SelectColor', 'SingleColor', 'Multicolor', 'SentimentColors']},
    {label: 'Horizontal Bar Chart', value: 'HBar', colorArray:['SelectColor', 'SingleColor', 'Multicolor', 'SentimentColors']},
    {label: 'Free Text', value: 'Text', colorArray:[]},
    {label: 'Hidden', value: 'Hidden', colorArray:[]},
  ]
  // <snapshotWidgetType>Pie or Donut or Box or HBar or VBar or Text or NA</snapshotWidgetType>
  // <snapshotWidgetType>Pie or Donut or Box or HBar or VBar or Text or NA</snapshotWidgetType>
  // <snapshotWidgetType>Pie or Donut or Box or HBar or VBar or Text or NA</snapshotWidgetType>

  const colorArr = [
    {label: 'Select Color', value: 'SelectColor'},
    {label: 'Single Color (Blue)', value: 'SingleColor'},
    {label: 'Multicolor', value: 'Multicolor'},
    {label: 'Sentiment Colors', value: 'SentimentColors'},
  ]

  const updateForm = (type, value) => {
    if(type === 'widgetType') {
      setWidgetTypeValue(value)
      if(value === 'NA' || value === 'Text') {
        setForm( prev => ({...prev, widgetType: value}))
      } else if(value === 'Hidden') {
        setForm( prev => ({...prev, widgetType: value, title: 'Hidden'}))
        setFreeText('')
      } else if (form?.data?.length === 0) {
        setForm( prev => ({...prev, widgetType: value, data:[initialRowData]}))
      } else {
        setForm( prev => ({...prev, widgetType: value}))
      }

      let clr = colorArr
      if(value === 'Pie'){ clr = colorArr.filter(f => f.value !== 'SingleColor') }
      else if(value === 'Box'){ clr = colorArr.filter(f => f.value !== 'Multicolor') }
      else if(value === 'Hidden'){ clr = [] }
      setColorArray(clr)
    }
    else if(type === 'color') { 
      setColorValue(value)
      setForm( prev => ({...prev, colorPallet: value}))
      let colors = []
      if(value === 'SingleColor'){ colors = ['#614ED8'] }
      else if(value === 'Multicolor'){ colors = GRAPH_COLOR_PALLET1 }
      else if(value === 'SentimentColors'){ colors = Object.values(LEGEND_COLOR_MAP) }
      setColorPallet(colors)
    }
    else if(type === 'title') { 
      setForm( prev => ({...prev, title: value}))
    }
    else if(type === 'displayValuesOutsidePie') {
      setForm( prev => ({...prev, displayValuesOutsidePie: value}))
    }
    else if(type === 'freeText') {
      const val = value?.length > 0 ? value : ' '
      setFreeText(val)
      setForm( prev => ({...prev, freeText: val}))
    }
    else if(type === 'Hidden') {
      setFreeText(null)
      setForm( prev => ({...prev, data:[], freeText: null}))
    }
  }

  const addRows = () => {
    const newData = [...form.data, initialRowData]
    setForm( prev => ({...prev, data:newData}))

    // inputRefs.push('input'+ newData.length-1);
    setTimeout(() => {
      const lastIndex = newData.length - 1
      if(inputRefs?.current?.[lastIndex]){
        inputRefs.current[lastIndex].focus()
      }
    }, 100);
  }

  const removeRow = (index) => {
    const newData = form.data
    newData.splice(index, 1);
    setForm( prev => ({...prev, data:newData}))
  }

  const applySentimentColors = () => {
    if(colorValue === 'SentimentColors' && form?.data?.length > 0){
      const colorArray = LEGEND_COLOR_MAP
      const colorArr = form.data.map(d => {
        if(d.value1.indexOf('+') !== -1) return colorArray.Positive
        if(d.value1.indexOf('-') !== -1) return colorArray.Negative
        if(d.value1.indexOf('~') !== -1) return colorArray.Mixed
        return colorArray.Neutral
      })

      if(JSON.stringify(colorArr) !== JSON.stringify(colorPallet)){
        setColorPallet(colorArr)
      }
    }
  }

  const updateRows = (index, key, value) => {
    const newData = form.data
    newData[index][key] = value
    setForm( prev => ({...prev, data:newData}))

    if(key === 'value1' && colorValue === 'SentimentColors' ) {
      applySentimentColors()
    }
    saveWidgetStatusFunc()
  }

  const keyChange = (event, index) => {
    if (widgetTypeValue !== 'Box' && event.key === 'Tab' && index === form.data.length -1) {
      addRows()
    }
  }

  const sanitizeFreeText = (text) => {
    if (typeof text !== 'string') return text;

    // 1. Remove unnecessary \n or \r characters
    text = text.replace(/\n/g, ''); // or replace with space: ' '
    text = text.replace(/\r/g, '');

    // 2. Escape invalid \ characters
    return text.replace(/\\(?![\\/"bfnrtu])/g, '\\\\');
  };

  const cleanedForm = {
      ...form,
      ...(form.widgetType === 'Text' && {
        freeText: sanitizeFreeText(form.freeText),
      }),
  };
  
  const onSubmit = () => {
    const updatedValues = {
      insightsElementId: insightsElementId,
      snapshotWidgetId: form.guid,
      snapshotWidgetTitle: form.title,
      snapshotWidgetType: widgetTypeValue,
      snapshotWidgetBlob: JSON.stringify(cleanedForm)
    }
    ReportsService.reportSetSnapshotWidgetApi(updatedValues)
    .then((resp) => {
      setLoading(false)
      onWidgetUpdated()
    })
    .catch((error) => {
      const resMessage = error
      console.log('ERROR : ', resMessage)
      setLoading(false)
    })
  }

  const onEditClick = (d) => {
    onClickEditContent(d)
  }

  const saveWidgetStatusFunc = () => {
    if( ['Pie', 'Donut', 'Box', 'VBar', 'HBar'].includes(widgetTypeValue) && colorValue !== 'SelectColor' && form?.data?.length > 0 && form?.data[0].label.length > 0 && form?.data[0].value1.length > 0){
      setSaveWidgetStatus(false)
    } else if (widgetTypeValue === 'Text' && freeText?.length > 0) {
      setSaveWidgetStatus(false)
    } else if (widgetTypeValue === 'Hidden') {
      setSaveWidgetStatus(false)
    } else {
      setSaveWidgetStatus(true)
    }
  }

  useEffect( () => {    
    const baseFormObject = {
      ...form,
      width: data.width,
      height: data.height,
      w: data.width * 290,
      h: data.height * 196,
    };

    setForm(baseFormObject);

    if (data?.json) {
      try {
        const jsonData = JSON.parse(data.json);
        if (!jsonData) return;

        const isTextWidget = jsonData?.widgetType === 'Text';
        const hasColorPallet = jsonData?.colorPallet;

        if (hasColorPallet || isTextWidget) {
          setForm({...jsonData, height:baseFormObject.height, width:baseFormObject.width, h:baseFormObject.h, w:baseFormObject.w});
          setMode('edit');
        }

        if (hasColorPallet) {
          setColorValue(jsonData.colorPallet);
        }

        if (isTextWidget) {
          setFreeText(jsonData.freeText);
          setShowFreeText(showFreeText + 1);
        }

        let clr = colorArr;
        if (widgetTypeValue === 'Pie') {
          clr = colorArr.filter(f => f.value !== 'SingleColor');
        } else if (widgetTypeValue === 'Box') {
          clr = colorArr.filter(f => f.value !== 'Multicolor');
        }
        setColorArray(clr);

      } catch (e) {
        console.error('Error parsing JSON:', e);
      }
    }

  }, [])

  useEffect(() => {
    if (form?.data?.length > 0) {
      const lastIndex = form.data.length - 1;
      if(inputRefs?.current?.[lastIndex]){
        inputRefs.current[lastIndex].focus();
      }
    }
  }, [form.data])

  useEffect(() => {
    saveWidgetStatusFunc()
  }, [form.data, colorValue, widgetTypeValue, freeText])

  useEffect(() => {
    applySentimentColors()
  }, [colorValue, form.data]);

  useEffect(() => {
    setTimeout(() => {
      setShowFreeText(showFreeText+1)
    }, 1000)
  }, [freeText])

  // useEffect(() => {
  //   console.log('showFreeText, freeText, mode =============', showFreeText, freeText, mode)
  // }, [showFreeText, freeText, mode])

  return (
    <Modal title={`Design Snapshot Widget ${data.id+1}`} showClose={true} onClose={onClose} styleType='themeV2'>
      <Wrapper>
        <WidgetWrapper>
          <LHS>
            <SectionTitle>Widget Basics</SectionTitle>
            <FormWrapper container spacing={2}>
              <InputWrapper>
                <MuiTextField
                  styletype='themeV2'
                  placeholder='Widget Title'
                  name='widgetTitle'
                  value={form.title}
                  onChange={(e) => updateForm('title', e.target.value) }
                  // disabled={form.widgetType === 'Hidden'}
                  disabled={['Hidden'].includes(widgetTypeValue)}
                />
              </InputWrapper>
              <SelectWrapper>
                <MuiTextField
                  styletype='themeV2'
                  value={`Width ${form.width}x`}
                  name='width'
                  disabled
                />
              </SelectWrapper>
              <SelectWrapper>
                <MuiTextField
                  styletype='themeV2'
                  value={`Height ${form.height}x`}
                  name='height'
                  disabled
                />
              </SelectWrapper>
              <SelectWrapper>
                <MuiSelect
                  styletype='themeV2'
                  name='widgetType'
                  placeholder={'Select Widget Type'}
                  onChange={(e) => updateForm('widgetType', e.target.value) }
                  data={widgetTypeArray}
                  selectlabel='label'
                  selectvalue='value'
                  value={widgetTypeValue}
                />
              </SelectWrapper>
              {colorArray?.length > 0 && <SelectWrapper>
                <MuiSelect
                  styletype='themeV2'
                  name='color'
                  placeholder={'Select Color'}
                  onChange={(e) => updateForm('color', e.target.value) }
                  data={colorArray}
                  selectlabel='label'
                  selectvalue='value'
                  value={colorValue}
                  disabled={['Text', 'Hidden'].includes(widgetTypeValue)}
                />
              </SelectWrapper>}
              
              {form.widgetType === 'Pie' && <MuiCheckbox
                styling='themeV2'
                size='small'
                name='DisplayValuesOutsidePie'
                label='Display Values Outside Pie'
                checked={form?.displayValuesOutsidePie}
                onChange={(e) => updateForm('displayValuesOutsidePie', e.checked) }
              />}
            </FormWrapper>

            {(form.data.length > 0 && colorValue !== 'SelectColor' && widgetTypeValue !== 'Text') && <>
              <SectionTitle>
                Widget Content
                <MuiButton
                  color='primary'
                  variant='text'
                  size='small'
                  onClick={() => addRows()}
                  startIcon={<IconAddRow />}
                  label='Add Segment'
                  className='addSegment'
                  disabled={form.widgetType === 'Box'}
                />
              </SectionTitle>
              <FormWrapper container spacing={2} className='content'>
                <FormInnerWrapper>
                  {form?.data && form.data.length > 0 && form.data.map((d, i) => {
                    const hideRow = ( widgetTypeValue === 'Box' && i > 0 ) ? 'hideRow' : ''
                    return (
                      <FormRow key={`formArray${i}`} className={`${hideRow}`}>
                        <InputWrapper>
                          <MuiTextField
                            ref={el => (inputRefs.current[i] = el)}
                            styletype='themeV2'
                            placeholder='Label'
                            name='widgetTitle'
                            value={d?.title || d.label}
                            onChange={(e) => updateRows(i, 'label', e.target.value) }
                          />
                        </InputWrapper>
                        <InputWrapper style={{width: '100px'}}>
                          <MuiTextField
                            styletype='themeV2'
                            placeholder='Value'
                            name='widgetValue1'
                            value={d.value1}
                            onChange={(e) => updateRows(i, 'value1', e.target.value) }
                            onKeyDown={(e) => keyChange(e, i)}
                          />
                        </InputWrapper>
                        {widgetTypeValue === 'Box' && <InputWrapper style={{width: '100px'}}>
                          <MuiTextField
                            styletype='themeV2'
                            placeholder='Value'
                            name='widgetValue2'
                            value={d.value2}
                            onChange={(e) => updateRows(i, 'value2', e.target.value) }
                            onKeyDown={(e) => keyChange(e, i)}
                          />
                        </InputWrapper>}
                        {widgetTypeValue !== 'Box' && <MuiButton
                          color='error'
                          variant='text'
                          size='small'
                          onClick={() => removeRow(i)}
                          startIcon={<IconMinusRow />}
                          style={{visibility: form.data.length === 1 ? 'hidden' : 'visible'}}
                        />}
                      </FormRow>
                    )
                  })}
                </FormInnerWrapper>
              </FormWrapper>
            </>}
            
            {widgetTypeValue === 'Text' && <>
              <SectionTitle>Widget Content</SectionTitle>
              <FormWrapper container spacing={2} className='content'>
                <FormInnerWrapper>
                  {(showFreeText && freeText && mode === 'edit') && <Rte
                      title={''}
                      value={freeText}
                      onChange={(e) => updateForm('freeText', e)}
                      height={350}
                      customToolbar={`bold italic underline strikethrough | subscript superscript | bullist numlist indent outdent fontsize | removeformat undo redo | link | table`}
                      content_style={RtePreviewCss}
                  />}
                  {(showFreeText && freeText === null && mode === 'edit') && <Rte
                      title={''}
                      value={freeText}
                      onChange={(e) => updateForm('freeText', e)}
                      height={350}
                      customToolbar={`bold italic underline strikethrough | subscript superscript | bullist numlist indent outdent fontsize | removeformat undo redo | link | table`}
                      content_style={RtePreviewCss}
                  />}
                  {(showFreeText && mode === 'add') && <Rte
                      title={''}
                      value={freeText}
                      onChange={(e) => updateForm('freeText', e)}
                      height={350}
                      customToolbar={`bold italic underline strikethrough | subscript superscript | bullist numlist indent outdent fontsize | removeformat undo redo | link | table`}
                      content_style={RtePreviewCss}
                  />}
                </FormInnerWrapper>
              </FormWrapper>
            </>}
          </LHS>
          <RHS>
            <SectionTitle style={{textAlign: 'center'}}>Widget Preview</SectionTitle>
            <PreviewInnerWrapper>
              <PreviewWrapper id='previewWrapper' style={{minHeight: `${form.h+40}px`}}>
                {
                  (
                    form?.title?.length>0 && widgetTypeValue !== 'NA' &&
                    ((colorPallet?.length > 0) || (widgetTypeValue === 'Text'))
                  )
                  ? <ViewWidget defaultType='View' data={form} onEditClicked={onEditClick} colorPallet={colorPallet} />
                  : <ViewWidget defaultType='View' data={form} onEditClicked={onEditClick}  />
                }

              </PreviewWrapper>
            </PreviewInnerWrapper>
          </RHS>
        </WidgetWrapper>
        <ActionWrapper>
          <MuiButton color='gray' variant='contained' label='Cancel' onClick={onClose} />
          <MuiButton color='primary' variant='contained' onClick={() => onSubmit(form)} label='Save Widget' disabled={saveWidgetStatus} />
        </ActionWrapper>
      </Wrapper>
    </Modal>
  )
}

export default EditWidget


